import {makeStyles} from '@material-ui/core/styles';

export default makeStyles(theme => ({
  wrapper: {
    position: 'fixed',
    left: 0,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('xs')]: {
      minHeight: theme.layout.headerHeight.mobile
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: theme.layout.headerHeight.desktop
    },
    paddingLeft: theme.layout.containerPaddingHorizontal,
    paddingRight: theme.layout.containerPaddingHorizontal,
    zIndex: theme.zIndex.appBar,
    background: theme.palette.secondary.light,
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      position: 'static',
      left: 'auto',
      top: 'auto',
      marginBottom: theme.spacing(2),
      background: 'none'
    }
  }
}));
